"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedBlackTree = void 0;
const createTree = require("functional-red-black-tree");
class RedBlackTree {
    internalTree;
    constructor(comparator) {
        this.internalTree = createTree(comparator);
    }
    get end() {
        return this.internalTree.end.node;
    }
    get begin() {
        return this.internalTree.begin.node;
    }
    insert(key, value) {
        this.internalTree = this.internalTree.insert(key, value);
        return this;
    }
    remove(key) {
        this.internalTree = this.internalTree.remove(key);
        return this;
    }
    find(key) {
        return this.internalTree.find(key).node;
    }
    get values() {
        return this.internalTree.values;
    }
    get keys() {
        return this.internalTree.keys;
    }
}
exports.RedBlackTree = RedBlackTree;
